import { graphql } from "../gql";

export const deleteCaseMutationDoc = graphql(`
  mutation deleteCase($id: ID!) {
    deleteCase(id: $id) {
      ...CaseFragment
    }
  }
`);
